import TagAndPillsContainer from "../../../Components/UiKits/Tag&Pills/TagAndPillsContainer";

const TagAndPills = () => {
  return <TagAndPillsContainer />;
};

export default TagAndPills;
